import { registerQuery } from 'data-fetching-client';
import { getPreviewCollections, getPublishedCollections, getRelevantCollectionIds } from '../../clients/qualityClient';
export const GET_PUBLISHED_COLLECTIONS_QUERY = registerQuery({
  fieldName: 'collections',
  args: ['appContext', 'offeringType', 'earlyRequestName'],
  fetcher: props => {
    return Promise.all([getRelevantCollectionIds(props), getPublishedCollections(props)]).then(([relevantIds, collections]) => {
      const relevantIdsSet = new Set(relevantIds.collectionIds);
      const relevantCollections = collections.collections.filter(collection => relevantIdsSet.has(collection.id));
      return {
        collections: relevantCollections
      };
    });
  }
});
export const GET_PREVIEW_COLLECTIONS_QUERY = registerQuery({
  fieldName: 'collections',
  args: ['appContext', 'offeringType'],
  fetcher: props => {
    if (props.appContext !== 'admin-preview') {
      return Promise.resolve({
        collections: []
      });
    } else {
      return getPreviewCollections(props);
    }
  }
});